export default [
  [`Размеры`, `2XS`, `XS`, `S`, `M`, `L`, `XL`, `2XL`, `3XL`],
  [`Российский размер`, `40`, `42`, `44`, `46`, `48`, `50`, `52`, `54`],
  [`Плечи`, `35,5`, `36,5`, `37,5`, `38,5`, `39,5`, `40,6`, `41,7`, `42,8`],
  [`Грудь`, `41`, `43`, `45`, `47`, `49`, `51`, `53`, `55`],
  [`Длина`, `58`, `58`, `58`, `60`, `60`, `62`, `62`, `62`]
];
